import React, { useState, useEffect, useRef } from 'react';
import { useNavigate,useLocation } from 'react-router-dom'
import {
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CModal, CModalBody, CModalFooter, CModalHeader, CFormInput,
    CFormTextarea
} from '@coreui/react'
import { FaSearch } from "react-icons/fa";
import { BsPersonPlus, BsChevronRight, BsPlayCircle, BsHeartPulse, BsEye, BsPencilSquare, BsTrash } from 'react-icons/bs';
import '../../../assets/css/mainstyle.css';
import '../../../assets/css/ClientSidebar.css';
import AddAppointmentModal from '../appointmentmanagment/addappointment'; // Le composant modal
import Adminprofil from '../../../assets/images/adminprofil.png';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import api from '../../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import { usePermissions } from '../../../contexts/PermissionContext';
import DoctorAppointment from '../../Doctorinterface/appointment';
import EditAppointmentModal from './editappointment';


const AppointmentList = () => {

    const [UserData, setUserData] = useState([]);
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [appointments, setAppointments] = useState([]);
    const [patients, setPatients] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalPatients, setTotalPatients] = useState(0);
    const [loadingg, setLoading] = useState(false);
    const limit = 10; // Nombre de patients par page
    const [showsignvitalModal, setShowSignvitalModal] = useState(false);
    const [departments, setDepartments] = useState([]);
    const { hasPermission, loading } = usePermissions();
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [cancelReason, setCancelReason] = useState('');
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [appointmentIdToEdit, setAppointmentIdToEdit] = useState(null);

    const location = useLocation();
    useEffect(() => {
      // Récupérer le token depuis l'URL
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      const showModal = urlParams.get('showModal'); // Vérifier si `showModal=true`
  
      // Si le token existe, on le stocke dans localStorage
      if (token) {
        localStorage.setItem('access_token', token);
        // Supprimer le token de l'URL pour qu'il ne reste pas visible
        window.history.replaceState({}, document.title, window.location.pathname);
      }
  
      // Afficher le modal si showModal est égal à 'true'
      if (showModal === 'true') {
        setVisible(true);
      }
    }, [location.search]);
  
    // Handle the viewing of appointment details
    const handleViewDetails = () => {
        setShowDetailsModal(true);
    };

    const handleOpenCancelModal = (appointmentId) => {
        setSelectedAppointment(appointmentId);
        setShowCancelModal(true);
    }

    // GEt patients list
    const fetchPatients = async (page = 1) => {
        setLoading(true);
        try {
            const response = await api.get(`/clinic/patients?page=${page}&limit=${limit}`);
            setPatients(response.data.patients);
            setTotalPages(response.data.totalPages);
            setTotalPatients(response.data.totalPatients);
            setCurrentPage(response.data.currentPage);
        } catch (error) {
            console.error('Erreur lors de la récupération des patients:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');

                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);


    // liste des appointments 
    useEffect(() => {
        const fetchAppointments = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    throw new Error('Token not found');
                }

                const hospitalIds = Array.isArray(UserData.hospital_id) ? UserData.hospital_id : [UserData.hospital_id];

                // Créez une requête pour chaque hospitalId
                const promises = hospitalIds.map(hospitalId =>
                    api.get(`/clinic/getAppointmentlist?hospitalId=${hospitalId._id || hospitalId}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                );

                const responses = await Promise.all(promises);

                // Combiner toutes les données des réponses
                const allAppointments = responses.flatMap(response => response.data);

                // Ajouter la vérification des signes vitaux pour chaque rendez-vous
                const appointmentsWithSignVitalStatus = await Promise.all(
                    allAppointments.map(async (appointment) => {
                        const signVitalExists = await fetchSignVitalStatus(appointment._id);
                        return {
                            ...appointment,
                            signVitalExists,  // Ajout de la propriété `signVitalExists` à l'objet appointment
                        };
                    })
                );

                setAppointments(appointmentsWithSignVitalStatus);

                // Filtrer les rendez-vous selon l'utilisateur
                if (UserData.role && UserData.role.name === 'medtinz_client_patient') {
                    const patientResponse = await api.get('/clinic/getPatientByUserId', {
                        headers: { Authorization: `Bearer ${token}` }
                    });

                    const patientId = patientResponse.data._id;
                    const filteredAppointments = appointmentsWithSignVitalStatus.filter(appointment =>
                        appointment.patientId._id === patientId
                    );

                    setAppointments(filteredAppointments);
                }
            } catch (error) {
                console.error('Error fetching appointments:', error);
                toast.error("Failed to fetch appointments");
            }
        };

        if (UserData && UserData.hospital_id) {
            fetchAppointments();
        }
    }, [UserData]);


    // listes des departments
    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await api.get(`/api/departments`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    }
                });

                // Mettre à jour les départements dans l'état
                setDepartments(response.data.data);
            } catch (error) {
                console.error('Erreur lors de la récupération des départements:', error);
            }
        };
        fetchDepartments(); // Appel de la fonction pour récupérer les départements
    }, []);


    // search
    const handleSearchChange = async (e) => {
        const value = e.target.value; // Récupérer la valeur entrée par l'utilisateur
        setSearchTerm(value);

        if (!value) {
            // Si le champ est vide, rechargez la liste complète
            fetchPatients(currentPage);
            return;
        }

        setLoading(true);
        try {
            const response = await api.get(`/clinic/patients/searchpatient`, {
                params: {
                    query: value, // Envoyer la valeur unique au backend
                },
            });
            setPatients(response.data); // Mettre à jour la liste des patients
        } catch (error) {
            console.error('Erreur lors de la recherche des patients:', error);
            setPatients([]); // Si une erreur se produit, afficher une liste vide
        } finally {
            setLoading(false);
        }
    };

    // Fonction pour vérifier si des signes vitaux existent pour un rendez-vous
    const fetchSignVitalStatus = async (appointmentId) => {
        try {
            const response = await api.get(`/clinic/signvitalforappointment/${appointmentId}`);
            return response.data.signVitaldata;
        } catch (error) {
            console.error('Erreur lors de la vérification des signes vitaux:', error);
            return false; // En cas d'erreur, on suppose qu'il n'y a pas de signes vitaux
        }
    };


    const handleAddOrEditSignsVital = async (appointmentId) => {
        const existingSignsVital = await fetchSignVitalStatus(appointmentId);
        navigate(`/appointment/${appointmentId}/signvital`, {
            state: { existingSignsVital },  // Passer les signes vitaux existants dans l'état de navigation
        });
    };

    const handleAppointmentAdded = (newAppointment) => {
        setAppointments((prev) => [...prev, newAppointment]);
    };

    // Fonction pour annuler un rendez-vous
    const handleCancelAppointment = async () => {
        if (!cancelReason) {
            toast.error('Please provide a reason for cancellation');
            return;
        }

        try {
            const token = localStorage.getItem('access_token');
            if (!token) {
                throw new Error('Token not found');
            }

            const response = await api.put(
                `/clinic/cancelappointments/${selectedAppointment}`,  // Utiliser l'ID stocké dans `selectedAppointment`
                { reasonForCancellation: cancelReason },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.status === 200) {
                toast.success('Appointment cancelled successfully');
                setShowCancelModal(false);
            } else {
                toast.error('Error cancelling appointment');
            }
        } catch (error) {
            console.error("Error cancelling appointment:", error);
            toast.error('Error cancelling appointment');
        }
    };

    const handleEditClick = (appointmentId) => {
        setAppointmentIdToEdit(appointmentId);
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
        setAppointmentIdToEdit(null);
    };

    return (
        <div className="dashboard-header" >
            <ToastContainer />
            <CHeader position="sticky" style={{ backgroundColor: '#DFEAF5' }}>
                <CContainer fluid className="d-flex align-items-center">
                    <div className='row w-100'>
                        {/* Barre de recherche */}
                        <div className="pagetittle col">
                            <h4><b>Appointment Management</b></h4>
                            <p>Home <BsChevronRight className='mx-2' style={{ fontSize: "12px" }} />  Dashboard <BsChevronRight style={{ fontSize: "12px" }} className='mx-2' />  <span style={{ color: '#191B1C' }}>Appointment Management</span></p>
                        </div>
                        {/* Profil utilisateur */}

                        <div className=' d-flex col justify-content-end'>
                            <CHeaderNav>
                                <CNavItem>
                                    <CNavLink href="#" className="d-flex ms-auto">
                                        <img src={Adminprofil} className='cardicon' alt="Consultation Icon" width={'50'} height={'50'} />
                                        <div>
                                            <span className="ms-2" style={{ color: 'black' }} >{UserData.firstname} {UserData.lastname}</span>
                                            <p className="ms-2" style={{ color: 'black' }} >{UserData.role?.name}</p>
                                        </div>
                                    </CNavLink>
                                </CNavItem>
                            </CHeaderNav>
                        </div>
                    </div>
                </CContainer>
            </CHeader>
            {UserData.role && UserData.role.name === 'medtinz_client_doctor' ? (
                <>
                    <div>
                        <DoctorAppointment />
                    </div>
                </>
            ) : (
                <div className="Patientlist mt-2"  >
                    <div className='tabsection'>
                        <CRow>
                            <CCol xs={12}>
                                <CCard className="card mb-4 p-4">
                                    <CCardBody>
                                        <div className='tablist ' >
                                            <div className='patientlistline'>
                                                <div className="search-container w-80">
                                                    <div className="search-bar">
                                                        <FaSearch size="sm" className="search-icon " style={{ width: '20px', height: '20px' }} />
                                                        <input
                                                            className='ms-4'
                                                            type="text"
                                                            placeholder="Search for a patient (Enter ID, name or Tel)"
                                                            value={searchTerm}
                                                            onChange={handleSearchChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='registeruserbtn ms-auto'>
                                                    <CButton onClick={() => setVisible(true)} className="registernewbtn ms-auto d-flex align-items-center" active tabIndex={-1}>
                                                        <BsPersonPlus className='mx-2' /> Book Appointment
                                                    </CButton>
                                                </div>

                                                <AddAppointmentModal
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    onAppointmentAdded={handleAppointmentAdded} />
                                            </div>
                                            {/* <div className=''>
                                            <div className="filter-bar">
                                                <button className="filter-button">
                                                    Filter By<FaFilter className="icon" />
                                                </button>
                                                <button className="filter-button">
                                                    Order Type<FaExchangeAlt className="icon" />
                                                </button>
                                                <button className="reset-button">
                                                    <FaRedoAlt className="icon" /> Reset Filter
                                                </button>
                                            </div>
                                        </div> */}

                                            <div className='patientlisttable'>
                                                <CTable className="mt-5 ctable-no-border " align="middle" responsive>
                                                    <CTableHead>
                                                        <CTableRow className='tablehead'>
                                                            <CTableHeaderCell scope="col">AppointmentID</CTableHeaderCell>
                                                            <CTableHeaderCell scope="col">Time</CTableHeaderCell>
                                                            <CTableHeaderCell scope="col">Date</CTableHeaderCell>
                                                            <CTableHeaderCell scope="col">Patient Name</CTableHeaderCell>
                                                            <CTableHeaderCell scope="col">Phone</CTableHeaderCell>
                                                            <CTableHeaderCell scope="col">Department</CTableHeaderCell>
                                                            <CTableHeaderCell scope="col">Status</CTableHeaderCell>
                                                            <CTableHeaderCell scope="col">Action</CTableHeaderCell>
                                                        </CTableRow>
                                                    </CTableHead>
                                                    <CTableBody>
                                                        {appointments.map((appointment) => (
                                                            <CTableRow className="ctable-row" key={appointment._id} style={{
                                                                background: appointment.type_consultation == "inperson" ? '#f8f9fa !important' : 'white !important'
                                                            }}
                                                            >
                                                                <CTableDataCell>{appointment.AppointmentCode || 'N/A'}</CTableDataCell>
                                                                <CTableDataCell>{appointment.appointmentTime || 'N/A'}</CTableDataCell>
                                                                <CTableDataCell>
                                                                    {appointment.appointmentDate?.split("T")[0] || 'N/A'}
                                                                </CTableDataCell>
                                                                <CTableDataCell>{appointment.patientId?.firstname || 'Unknown'} {appointment.patientId?.lastname || 'Unknown'}</CTableDataCell>
                                                                <CTableDataCell>{appointment.patientId?.phone || 'N/A'}</CTableDataCell>
                                                                <CTableDataCell> {
                                                                    // Find the department name based on the department ID
                                                                    departments.find(department => department._id === appointment.department)?.name || 'N/A'
                                                                }</CTableDataCell>
                                                                <CTableDataCell>
                                                                    <span className={appointment.status === 'Scheduled' ? 'coloredsucess' : 'coloredechec'}>
                                                                        {appointment.status}
                                                                    </span>
                                                                </CTableDataCell>
                                                                <CTableDataCell style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                                                                    {hasPermission('medtinz_client_telemedecine_create') && (
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Start Consultation</Tooltip>}>
                                                                            <a
                                                                                href={
                                                                                    appointment?.type_consultation === 'online'
                                                                                        ? `/hospitaladmin/telemedecine?patient_id=${appointment?.patientId?._id}&appointmentId=${appointment._id}`
                                                                                        : `/hospitaladmin/intakeformconsult?patient_id=${appointment?.patientId?._id}&appointmentId=${appointment._id}`
                                                                                }
                                                                                className={appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'disabled' : ''}
                                                                                style={{
                                                                                    color: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? '#6c757d' : '#0d6efd',
                                                                                    fontSize: '1.5rem',
                                                                                    pointerEvents: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'none' : 'auto'
                                                                                }}
                                                                            >
                                                                                <BsPlayCircle />
                                                                            </a>
                                                                        </OverlayTrigger>
                                                                    )}

                                                                    {hasPermission('medtinz_client_patient_add_vital_sign') && (
                                                                        <OverlayTrigger
                                                                            placement="top"
                                                                            overlay={<Tooltip>{appointment.signVitalExists ? 'Edit Vital Signs' : 'Add Vital Signs'}</Tooltip>}
                                                                        >
                                                                            <span
                                                                                onClick={appointment.status !== 'Cancelled' && appointment.paymentStatus !== false ? () => handleAddOrEditSignsVital(appointment._id) : null}
                                                                                style={{
                                                                                    color: appointment.signVitalExists ? '#198754' : '#0d6efd',
                                                                                    fontSize: '1.5rem',
                                                                                    cursor: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'default' : 'pointer',
                                                                                    pointerEvents: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'none' : 'auto'
                                                                                }}
                                                                            >
                                                                                <BsHeartPulse />
                                                                            </span>
                                                                        </OverlayTrigger>
                                                                    )}

                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>View Details</Tooltip>}>
                                                                        <span
                                                                            onClick={appointment.status !== 'Cancelled' && appointment.paymentStatus !== false ? () => handleViewDetails(appointment._id) : null}
                                                                            style={{
                                                                                color: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? '#6c757d' : '#0dcaf0',
                                                                                fontSize: '1.5rem',
                                                                                cursor: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'default' : 'pointer',
                                                                                pointerEvents: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'none' : 'auto'
                                                                            }}
                                                                        >
                                                                            <BsEye />
                                                                        </span>
                                                                    </OverlayTrigger>

                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Edit Appointment</Tooltip>}>
                                                                        <span
                                                                            onClick={appointment.status !== 'Cancelled' && appointment.paymentStatus !== false ? () => handleEditClick(appointment._id) : null}
                                                                            style={{
                                                                                color: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? '#6c757d' : '#ffc107',
                                                                                fontSize: '1.5rem',
                                                                                cursor: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'default' : 'pointer',
                                                                                pointerEvents: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'none' : 'auto'
                                                                            }}
                                                                        >
                                                                            <BsPencilSquare />
                                                                        </span>
                                                                    </OverlayTrigger>

                                                                    <EditAppointmentModal
                                                                        visible={isModalVisible}
                                                                        onClose={handleModalClose}
                                                                        appointmentId={appointmentIdToEdit}
                                                                    />

                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Cancel Appointment</Tooltip>}>
                                                                        <span
                                                                            onClick={appointment.status !== 'Cancelled' && appointment.paymentStatus !== false ? () => handleOpenCancelModal(appointment._id) : null}
                                                                            style={{
                                                                                color: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? '#6c757d' : '#dc3545',
                                                                                fontSize: '1.5rem',
                                                                                cursor: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'default' : 'pointer',
                                                                                pointerEvents: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'none' : 'auto'
                                                                            }}
                                                                        >
                                                                            <BsTrash />
                                                                        </span>
                                                                    </OverlayTrigger>
                                                                    {/* Modal for Cancel Reason */}

                                                                    <CModal visible={showCancelModal} onClose={() => setShowCancelModal(false)}>
                                                                        <CModalHeader closeButton>
                                                                            <h5>Cancel Appointment</h5>
                                                                        </CModalHeader>
                                                                        <CModalBody>
                                                                            <CFormTextarea
                                                                                type="text"
                                                                                placeholder="Enter reason for cancellation"
                                                                                value={cancelReason}
                                                                                onChange={(e) => setCancelReason(e.target.value)}
                                                                            />
                                                                        </CModalBody>
                                                                        <CModalFooter>
                                                                            <CButton color="secondary" onClick={() => setShowCancelModal(false)}>
                                                                                Close
                                                                            </CButton>
                                                                            <CButton color="danger" onClick={handleCancelAppointment}>
                                                                                Cancel Appointment
                                                                            </CButton>
                                                                        </CModalFooter>
                                                                    </CModal>

                                                                    {/* Modal for Viewing Appointment Details */}
                                                                    <CModal visible={showDetailsModal} onClose={() => setShowDetailsModal(false)}>
                                                                        <CModalHeader closeButton>
                                                                            <h5>Appointment Details</h5>
                                                                        </CModalHeader>
                                                                        <CModalBody>
                                                                            <p><strong>Patient Name:</strong> {appointment.patientId?.name}</p>
                                                                            <p><strong>Doctor Name:</strong> {appointment.doctorId?.name}</p>
                                                                            <p><strong>Appointment Date:</strong> {appointment.appointmentDate}</p>
                                                                            <p><strong>Appointment Time:</strong> {appointment.appointmentTime}</p>
                                                                            <p><strong>Purpose of Visit:</strong> {appointment.purposeOfVisit}</p>
                                                                            <p><strong>Notes:</strong> {appointment.notes}</p>
                                                                        </CModalBody>
                                                                        <CModalFooter>
                                                                            <CButton color="secondary" onClick={() => setShowDetailsModal(false)}>
                                                                                Close
                                                                            </CButton>
                                                                        </CModalFooter>
                                                                    </CModal>
                                                                </CTableDataCell>
                                                            </CTableRow>
                                                        ))}
                                                    </CTableBody>
                                                </CTable>
                                            </div>
                                        </div>
                                    </CCardBody>
                                </CCard>
                            </CCol>
                        </CRow>
                    </div>
                </div>

            )
            }
        </div >


    );
}

export default AppointmentList;
